import React, { ReactElement } from 'react';
import './styles/PinNumberKeypad.scss';
import { Fragment, useState, useRef } from 'react';
import { MD5 } from 'crypto-js'; //this component uses crypto-js, pin-numbers tied to user account are hased on the db

//muis
import BackspaceIcon from '@mui/icons-material/Backspace';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
    shouldVerificationKey: string, SetShouldVerificationKey: any,
    verificationMessage: string, SetVerificationMessage: any,
    SuccessAction: any, ResetPinAction: any
}

const PinNumberKeypad: React.FC<Props> = ({
    shouldVerificationKey, SetShouldVerificationKey,
    verificationMessage, SetVerificationMessage,
    SuccessAction, ResetPinAction
}) => {
    //states
    const [userInputKey, SetUserInputKey] = useState('');
    //refs
    const userInputKeyRef = useRef<string>(userInputKey);
    const previousVerificationMessageRef = useRef<string>('');

    //ui functions
    const OnKeyPressed = (key: string) => {
        if(userInputKeyRef.current.length < 6) {
            userInputKeyRef.current += key;
            SetUserInputKey(userInputKeyRef.current);
        }
    }
    const OnBackspaceClicked = () => {
        userInputKeyRef.current = userInputKeyRef.current.substring(0, userInputKeyRef.current.length - 1);
        SetUserInputKey(userInputKeyRef.current);
    }
    const OnVerifyClicked = () => {
        if (userInputKey.length == 6 && MD5(userInputKey) == shouldVerificationKey) {
            SuccessAction();
        } else {
            previousVerificationMessageRef.current = verificationMessage;
            SetVerificationMessage('Wrong pin number, please try again.');
            setTimeout(() => {
                SetVerificationMessage(previousVerificationMessageRef.current);
            }, 3000);

            userInputKeyRef.current = '';
            SetUserInputKey(userInputKeyRef.current);
        }
    }

    //exe functions
    const GenerateHideBlocksFromKey = (keys: string) => {
        const keyArr = keys.split('');
        const elems = [] as ReactElement[];
        keyArr.map((key: string, i: number) => {
            elems.push(
                <div className='PinNumberKeypad-hide-block' key={'PinNumberKeypad-hihde-block-' + i}/>
            )
        });
        return elems;
    }

    return (
        shouldVerificationKey.length > 0 ?
            <div className='PinNumberKeypad'>
                <div className='PinNumberKeypad-block-mask' />
                <div className='PinNumberKeypad-menu'>

                    <span className='PinNumberKeypad-menu-lbl'>6-digit PIN</span>
                    <span className='PinNumberKeypad-menu-title'>{verificationMessage}</span>
                    <div className='PinNumberKeypad-menu-txt'>{ GenerateHideBlocksFromKey(userInputKey) }</div>
                    <button className='PinNumberKeypad-menu-forgot-pin-btn' onClick={() => ResetPinAction()}>Forgot PIN</button>

                    <div className='PinNumberKeypad-keypad'>
                        <div className='PinNumberKeypad-keypad-row'>
                            <button className='PinNumberKeypad-keypad-btn' onClick={() => OnKeyPressed('1')}>1</button>
                            <button className='PinNumberKeypad-keypad-btn' onClick={() => OnKeyPressed('2')}>2</button>
                            <button className='PinNumberKeypad-keypad-btn' onClick={() => OnKeyPressed('3')}>3</button>
                        </div>
                        <div className='PinNumberKeypad-keypad-row'>
                            <button className='PinNumberKeypad-keypad-btn' onClick={() => OnKeyPressed('4')}>4</button>
                            <button className='PinNumberKeypad-keypad-btn' onClick={() => OnKeyPressed('5')}>5</button>
                            <button className='PinNumberKeypad-keypad-btn' onClick={() => OnKeyPressed('6')}>6</button>
                        </div>
                        <div className='PinNumberKeypad-keypad-row'>
                            <button className='PinNumberKeypad-keypad-btn' onClick={() => OnKeyPressed('7')}>7</button>
                            <button className='PinNumberKeypad-keypad-btn' onClick={() => OnKeyPressed('8')}>8</button>
                            <button className='PinNumberKeypad-keypad-btn' onClick={() => OnKeyPressed('9')}>9</button>
                        </div>
                        <div className='PinNumberKeypad-keypad-row'>
                            <button className='PinNumberKeypad-keypad-btn' onClick={() => OnBackspaceClicked()}><BackspaceIcon /></button>
                            <button className='PinNumberKeypad-keypad-btn' onClick={() => OnKeyPressed('0')}>0</button>
                            <button className='PinNumberKeypad-keypad-btn' onClick={() => OnVerifyClicked()}><CheckCircleIcon /></button>
                        </div>
                    </div>

                    <button className='PinNumberKeypad-close-btn' onClick={() => SetShouldVerificationKey('')}><CloseIcon /></button>
                </div>
            </div>
            :
            null
    )
}
export default PinNumberKeypad;